var React = require('react');

function Percentage (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M365.25 338.74a64 64 0 1 0 0 90.51 64 64 0 0 0 0-90.51zm-346.51-256a64 64 0 1 0 90.51 0 64 64 0 0 0-90.51 0z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M363.31 152.56L88.56 427.31a32 32 0 0 1-45.25 0l-22.62-22.62a32 32 0 0 1 0-45.25L295.44 84.69a32 32 0 0 1 45.25 0l22.62 22.62a32 32 0 0 1 0 45.25z","className":"fa-primary","key":2})]);
}

Percentage.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Percentage;

Percentage.default = Percentage;
